import React, { useMemo } from 'react';
import { Slide } from '@mui/material';

const MusicPlayer = ({ disabled, isZenMode }) => {
  const height = isZenMode ? '100px' : '197px';
  const width = '350px';

  // ✅ Only generate once
  const youtubeIframe = useMemo(() => {
    return (
<iframe
  style={{ borderRadius: '30px' }}
  src="https://www.youtube.com/embed/videoseries?list=PL0NlPMZoZi-rLAwL6eTV6ynEzpXpPunq-"
  width={width}
  height={height}
  frameBorder="0"
  allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
  title="MusicPlayer"
/>

    );
  }, [height, width]); // only regenerates if size changes

  return (
    <Slide
      direction="up"
      style={{ transitionDelay: disabled ? '200ms' : '0ms' }}
      in={!disabled}
      mountOnEnter
      unmountOnExit
    >
      <div>
        {/* ✅ Do not use dangerouslySetInnerHTML — directly render JSX */}
        {!disabled && youtubeIframe}
      </div>
    </Slide>
  );
};

export default MusicPlayer;
